import axios from 'axios'
import { parse } from 'query-string'
import { CookieComponent } from '../../../_metronic/assets/ts/components/_CookieComponent'
import { logoutUser } from '../auth/auth-utils'
import { FC, useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { AlexiApplicationTypes } from '../../../utils/constants/AlexiApplicationType.enum'
import { getIntegrationURLFromENV, handleSettingEnv } from '../../../utils/getIntegrationURLFromENV'
import { setPartnerDetails, setUser } from './redux/actions'
import { LoanApplicationLocalStorageKeys } from '../../../utils/constants/LocalStorageKeys.enum'
import './AgentLoanType.scss'
import {
  Typography,
  InputLabel,
  TextField,
  FormHelperText,
  BoxProps,
  styled,
  Box as MuiBox,
  Button,
  FormControl,
  Container,
  Link,
} from '@mui/material'
import OtpInput from 'react-otp-input'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { BACKEND_API_CHANNEL_PARTNER } from '../../../utils/constants/api-constants'
import Alert from '../../../_metronic/partials/alert'

const RightWrapper = styled(MuiBox)<BoxProps>(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('md')]: {
    maxWidth: 600,
  },
}))

const BoxWrapper = styled(MuiBox)<BoxProps>(({ theme }) => ({
  [theme.breakpoints.down('xl')]: {
    width: '100%',
  },
  [theme.breakpoints.down('md')]: {
    maxWidth: 400,
  },
}))

const AgentClientType: FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  let { type } = useParams<{ type: string; agentCode: string }>()
  const searchQuery: any = parse(history.location.search)
  const [userId, setUserId] = useState<string>('')
  const [showAlert, setShowAlert] = useState<boolean>(false)
  const [alertType, setAlertType] = useState<any>('primary')
  const [alertMsg, setAlertMsg] = useState<string>('')

  useEffect(() => {
    // Use the centralized logout function
    logoutUser()
    handleSettingEnv(searchQuery?.env)
    localStorage.removeItem(LoanApplicationLocalStorageKeys.LOAN_APPLICATION_SUBMISSION_METHOD)

    /**
     * Setting Partner Id
     */
    getPartnerDetails(searchQuery?.partner || localStorage.getItem('partnerId'))
    // eslint-disable-next-line
  }, [])

  const getPartnerDetails = async (partnerId: string) => {
    const env = localStorage.getItem('env')
    const API_URL = getIntegrationURLFromENV(searchQuery?.env || env)

    let PARTNER_FETCH_URL = `${API_URL}ext/api/businesspartner/${partnerId || ''}`
    if (env === 'prod') {
      if (!partnerId) {
        PARTNER_FETCH_URL = `${API_URL}ext/api/businesspartner/2fcaefce-b14e-4774-ab53-ed9ee62a2ef2`
      }
    }

    const partnerData = await axios.get(PARTNER_FETCH_URL)

    if (partnerData.data && partnerData.status === 200) {
      localStorage.setItem('partnerId', partnerData.data?.id)
      localStorage.setItem('partnerDetails', JSON.stringify(partnerData.data))
      dispatch(setPartnerDetails(partnerData.data))
    }
  }

  // const loanApplicationId = localStorage.getItem('loanApplicationId');
  if (type && type.toLowerCase() === AlexiApplicationTypes.RECURRING_APPLICATION)
    localStorage.setItem('loanType', AlexiApplicationTypes.RECURRING_APPLICATION)
  else {
    localStorage.setItem('loanType', AlexiApplicationTypes.LOAN_APPLICATION)
    localStorage.setItem('applicationType', AlexiApplicationTypes.AGENT_CLIENT_ONBOARDING)
  }
  if (type === null || type === undefined) {
    localStorage.setItem('loanType', AlexiApplicationTypes.LOAN_APPLICATION)
    localStorage.setItem('applicationType', AlexiApplicationTypes.AGENT_CLIENT_ONBOARDING)
  }
  localStorage.removeItem('loanApplicationId')

  const [otpSent, setOtpSent] = useState<boolean>(false)
  // eslint-disable-next-line
  const [loading, setLoading] = useState<boolean>(false)
  const [email, setEmail] = useState<string>('')
  const [otp, setOtp] = useState<string>('')
  const [emailError, setEmailError] = useState<string>('')
  const [otpError, setOtpError] = useState<string>('')

  const [timer, setTimer] = useState(0)
  const timeOutCallback = useCallback(() => setTimer((currTimer) => currTimer - 1), [])

  useEffect(() => {
    if (timer > 0) {
      const id = setTimeout(timeOutCallback, 1000)
      return () => clearTimeout(id)
    } else {
      setTimer(0)
    }
  }, [timer, timeOutCallback])

  const resetTimer = () => {
    if (!timer) {
      setTimer(40)
    }
  }

  const sendOtp = async (e: React.FormEvent) => {
    e.preventDefault()
    setEmailError('')
    setOtpError('')
    setOtp('')
    if (!email) {
      setEmailError('Email is required.')
      return
    }
    // Basic email format validation
    if (!/^[\w-.+]+@([\w-]+\.)+[\w-]{2,63}$/g.test(email)) {
      setEmailError('Please enter a valid email address.')
      return
    }
    try {
      setLoading(true)
      // Mock API call for sending OTP
      // Replace with actual API call
      const env = localStorage.getItem('env')
      const response = await axios.post(
        `${env === 'stage'
          ? 'https://stage-ccr-backend.credilinq.ai/'
          : process.env.REACT_APP_BACKEND_API_URL
        }${BACKEND_API_CHANNEL_PARTNER.GENERATE_CHANNEL_PARTNER_OTP}`,
        {
          email,
        }
      )
      // Use the centralized logout function to ensure all tabs are notified
      logoutUser()
      localStorage.removeItem('agentCode')
      localStorage.removeItem('userDetails')

      if (response.data?.status === 200) {
        setUserId(response.data?.data?.id)

        setOtpSent(true)
        setLoading(false)
        resetTimer()
      } else {
        setEmailError(
          'You are not authorized to use the system, please contact <a href="mailto:loansupport@ccrpartners.co" style="color: var(--error-red) !important; text-decoration: underline !important">loansupport@ccrpartners.co</a>'
        )
        setLoading(false)
      }
    } catch (err: any) {
      setLoading(false)
      setEmailError(err?.response?.data?.message || 'Failed to send OTP. Please try again.')
    }
  }
  const validateOtp = async (e: React.FormEvent) => {
    e.preventDefault()
    setOtpError('')
    if (!otp || otp.length !== 4) {
      setOtpError('Please enter a 4-digit OTP.')
      return
    }
    // Check if OTP contains any alphabetic characters
    if (/[a-zA-Z]/.test(otp)) {
      setOtpError('Please enter a valid OTP with numbers only.')
      return
    }
    // Check if OTP contains any non-numeric characters
    if (!/^\d+$/.test(otp)) {
      setOtpError('Please enter a valid OTP with numbers only.')
      return
    }
    try {
      setLoading(true)
      // Mock API call for validating OTP
      // Replace with actual API call
      const env = localStorage.getItem('env')
      const response = await axios.post(
        `${env === 'stage'
          ? 'https://stage-ccr-backend.credilinq.ai/'
          : process.env.REACT_APP_BACKEND_API_URL
        }${BACKEND_API_CHANNEL_PARTNER.VALIDATE_CHANNEL_PARTNER_OTP}`,
        {
          id: userId,
          otp: Number(otp),
        }
      )
      if (response.data?.status === 200) {
        // Set auth data in localStorage
        localStorage.setItem('isAuthorised', 'true')
        localStorage.setItem('agentCode', response.data?.data?.id)
        dispatch(setUser(response.data?.data?.userExist))
        localStorage.setItem('userDetails', JSON.stringify(response.data?.data?.userExist))
        setTimeout(() => {
          // Check if there's a returnTo URL parameter to redirect back to the original page
          const returnTo = searchQuery?.returnTo
          if (returnTo) {
            history.push(decodeURIComponent(returnTo))
          } else {
            history.push('/agent-application/view/dashboard')
          }
        }, 1000)
        // Set KeystoneJS session cookie
        if (response.data?.data?.token) {
          // Create an expiration date 1 days from now
          const expirationDate = new Date()
          // expirationDate.setMinutes(expirationDate.getMinutes() + 1)
          expirationDate.setDate(expirationDate.getDate() + 1)
          // Set the session cookie using the built-in CookieComponent
          CookieComponent.set('keystone-agent-js-session', response.data?.data?.token, {
            expires: expirationDate,
            path: '/',
            secure: true,
            sameSite: 'None',
          })
        }
      } else {
        setShowAlert(true)
        setAlertMsg(response.data?.friendlyErrorMessage)
        setAlertType('primary')

        history.push('/agent-application/login')
      }

      setLoading(false)
    } catch (err: any) {
      console.log(err)
      setLoading(false)
      setOtpError(err?.response?.data?.message || 'Failed to validate OTP. Please try again.')
    }
  }
  const handleResendOtp = async (e: React.FormEvent) => {
    e.preventDefault()
    setOtpError('')
    setEmailError('')
    setOtp('')
    try {
      setLoading(true)
      sendOtp(e).then(() => {
        setOtpSent(true)
        setLoading(false)
        setShowAlert(true)
        setAlertMsg('OTP Resent Successfully!')
        setAlertType('success')
      })
    } catch (err: any) {
      setLoading(false)
      setEmailError(err?.response?.data?.message || 'Failed to resend OTP. Please try again.')
    }
  }

  const handleReset = () => {
    setEmailError('')
    setEmail('')
    setOtpError('')
  }

  return (
    <>
      <Container className='container-fluid'>
        <MuiBox className='content-right'>
          <RightWrapper>
            <MuiBox
              sx={{
                p: 5,
                pt: 10,
                height: '100%',
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'center',
              }}
            >
              <BoxWrapper sx={{ width: '100%', maxWidth: '400px' }}>
                <MuiBox
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    mb: '48px',
                  }}
                >
                  <img
                    alt='logo'
                    loading='lazy'
                    width='200'
                    height='90'
                    decoding='async'
                    data-nimg='1'
                    src={toAbsoluteUrl('/media/logos/ccrLogo.png')}
                  />
                </MuiBox>
                {!otpSent && (
                  <form onSubmit={(e) => sendOtp(e)}>
                    <Typography
                      className='otp-maintitle'
                      variant='h6'
                      gutterBottom
                      sx={{ mb: '20px', mt: '20px', maxWidth: '300px', margin: '20px auto' }}
                    >
                      Welcome to CCR Partners Sales Referral Portal
                    </Typography>

                    <Container className='signin-form-container'>
                      <InputLabel>Email ID</InputLabel>
                      <div className='signin-form-input-container '>
                        <TextField
                          id='email'
                          variant='outlined'
                          placeholder='abc@gmail.com'
                          margin='normal'
                          error={Boolean(emailError)}
                          className='signin-form-field'
                          onChange={(e) => {
                            e.target.value === '' ? handleReset() : setEmail(e.target.value)
                            setEmailError('')
                          }}
                          label={false}
                          InputLabelProps={{ shrink: true }}
                          value={email}
                          sx={{
                            MuiOutlinedInput: {
                              styleOverrides: {
                                root: {
                                  '&:hover:not(.Mui-focused):not(.Mui-disabled) .MuiOutlinedInput-notchedOutline':
                                  {
                                    borderColor: 'var(--primary-color)',
                                  },
                                  '&:hover.Mui-error .MuiOutlinedInput-notchedOutline': {
                                    borderColor: 'var(--primary-color)',
                                  },
                                  '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: 'var(--primary-color)',
                                  },
                                  '&.Mui-disabled .MuiLabel .MuiOutlinedInput-notchedOutline': {
                                    borderColor: 'var(--primary-color)',
                                  },
                                },
                              },
                            },
                          }}
                        />
                        {emailError && (
                          <p
                            className='signin-error-msg'
                            dangerouslySetInnerHTML={{ __html: emailError }}
                          ></p>
                        )}
                      </div>

                      <Button
                        fullWidth
                        size='large'
                        type='button'
                        variant='contained'
                        className='button-primary signin-btn'
                        sx={{
                          textTransform: 'none',
                        }}
                        disabled={loading || email === '' || emailError !== ''}
                        onClick={(e) => {
                          if (!otpSent) {
                            sendOtp(e)
                          } else {
                            validateOtp(e)
                          }
                        }}
                      >
                        Continue
                      </Button>
                    </Container>
                  </form>
                )}
                {otpSent && (
                  <form onSubmit={(e) => validateOtp(e)}>
                    <Typography
                      className='otp-maintitle '
                      variant='h6'
                      gutterBottom
                      sx={{ mb: '20px', mt: '20px' }}
                    >
                      OTP
                    </Typography>
                    <Typography
                      className='otp-subtitle'
                      variant='body1'
                      gutterBottom
                      sx={{ textAlign: 'center' }}
                    >
                      Enter 4-Digit OTP send to your mail ID <br />
                      {email}{' '}
                      <Link
                        sx={{ textDecoration: 'underline !important' }}
                        onClick={() => {
                          setOtpSent(false)
                          setOtp('')
                          setOtpError('')
                          setEmailError('')
                        }}
                      >
                        Edit
                      </Link>
                    </Typography>
                    <FormControl fullWidth>
                      <Typography
                        variant='h6'
                        className='otp-title'
                        sx={{ mb: '10px', mt: '15px' }}
                      >
                        Enter OTP <span className='error-color'>*</span>
                      </Typography>
                      <div className='signin-form-input-container'>
                        <OtpInput
                          value={otp}
                          onChange={setOtp}
                          containerStyle='signin-otp-inputbox-container'
                          numInputs={4}
                          renderInput={(props: any) => <input {...props} />}
                        />
                        {otpError && (
                          <FormHelperText sx={{ color: 'error.main', margin: 0 }}>
                            {otpError}
                          </FormHelperText>
                        )}
                      </div>
                      <div className='otp-resend-container'>
                        <Typography
                          onClick={(e) => timer <= 0 && handleResendOtp(e)}
                          variant='h6'
                          className={`otp-title ${timer <= 0 && 'otp-resend'}`}
                          sx={{
                            color:
                              timer <= 0
                                ? 'var(--link-color) !important'
                                : 'var(--text-color-a) !important',
                            cursor: timer <= 0 ? 'poiter !important' : 'auto !important',
                          }}
                        >
                          Resend OTP
                        </Typography>
                        <Typography variant='body1' className='timer-title'>
                          {timer > 0 ? `Resend OTP  after  ${timer} secs` : null}
                        </Typography>
                      </div>
                    </FormControl>
                    <Button
                      size='large'
                      fullWidth
                      type='submit'
                      variant='contained'
                      className='button-primary signin-btn'
                      sx={{
                        textTransform: 'none',
                      }}
                      disabled={loading || otp?.length !== 4}
                      onClick={(e) => {
                        if (!otpSent) {
                          sendOtp(e)
                        } else {
                          validateOtp(e)
                        }
                      }}
                    >
                      Verify Now
                    </Button>
                    <Container className='signin-otp-divider'>
                      <div className='sigin-linle'></div>
                      <span>OR </span>
                      <div className='sigin-linle'></div>
                    </Container>
                    <Button
                      className='button-secondary signin-btn'
                      onClick={() => {
                        setOtpSent(false)
                        setOtpError('')
                        setEmailError('')
                        setOtp('')
                      }}
                      variant='outlined'
                      color='primary'
                      disabled={loading}
                    >
                      Back To Login
                    </Button>
                  </form>
                )}
              </BoxWrapper>
            </MuiBox>
          </RightWrapper>
        </MuiBox>

        {showAlert && (
          <Alert variant={alertType} showAlert={showAlert} setShowAlert={setShowAlert}>
            {alertMsg}
          </Alert>
        )}
      </Container>
    </>
  )
}

export default AgentClientType
